<template>
  <div class="site-layout">
    <app-navbar></app-navbar>
    <div class="router-container">
      <router-view />
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppNavbar from '@/components/Layout/AppNavbar.vue';
import AppFooter from '@/components/Layout/AppFooter.vue';

export default {
  name: 'no-points-layout',
  components: {
    AppNavbar,
    AppFooter,
  },
};
</script>

<style lang="scss" scoped>
.app-navbar {
  z-index: 2;
}
.app-footer {
  margin-top: 48px;
}
.router-container {
  position: relative;
  padding-top: var(--navbar-height);
  min-height: 100vh;
  z-index: 1;

  .app-points-container {
    margin-bottom: 32px;
  }
}
</style>
